(() => {
  if (window.__lbReleasitGiftsLoaded) return;
  const seedElement = document.getElementById('lb-releasit-gifts-data');
  if (!seedElement) return;
  let seed;
  try { seed = JSON.parse(seedElement.textContent); } catch { return; }
  window.__lbReleasitGiftsLoaded = true;
  const gifts = new Map();
  const pendingProducts = new Map();
  const prefix = typeof seed.prefix === 'string' ? seed.prefix : '';
  let modal = null;
  let modalObserver = null;
  let scheduled = false;

  function remember(product) {
    if (!product || !product.id || !product.variants) return;
    for (const [variant, text] of Object.entries(product.variants)) {
      gifts.set(variant, typeof text === 'string' ? text.replace(/\s+/g, ' ').trim() : '');
    }
  }

  remember(seed.product);
  for (const product of seed.cart || []) remember(product);

  function requestGifts(row) {
    const link = row.querySelector('a._rsi-modal-line-item-title');
    if (!link) return;
    let url;
    try { url = new URL(link.href, location.href); } catch { return; }
    if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return;
    url.search = '';
    url.hash = '';
    url.searchParams.set('view', 'lb-releasit-gifts');
    const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
    if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
    const key = url.href;
    if (pendingProducts.has(key)) return;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    const request = fetch(key, {credentials: 'same-origin', signal: controller.signal})
      .then(response => response.ok ? response.json() : null)
      .then(product => { remember(product); schedule(); })
      .catch(() => {})
      .finally(() => clearTimeout(timeout));
    pendingProducts.set(key, request);
  }

  function render() {
    scheduled = false;
    if (!modal || !modal.isConnected) return;
    const retained = new Set();
    for (const row of modal.querySelectorAll('._rsi-modal-line-item[data-line-item-variant-id]')) {
      const variant = row.dataset.lineItemVariantId;
      if (!gifts.has(variant)) requestGifts(row);
      const text = gifts.get(variant);
      let block = row.nextElementSibling;
      if (!block || !block.classList.contains('lb-releasit-gifts')) block = null;
      if (!text) {
        if (block) block.remove();
        continue;
      }
      if (!block) {
        block = document.createElement('div');
        block.className = 'lb-releasit-gifts';
        row.after(block);
      }
      const value = prefix + ' ' + text;
      if (block.textContent !== value) block.textContent = value;
      if (block.dataset.lbGiftFor !== variant) block.dataset.lbGiftFor = variant;
      retained.add(block);
    }
    for (const block of modal.querySelectorAll('.lb-releasit-gifts')) {
      if (!retained.has(block)) block.remove();
    }
  }

  function schedule() {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(render);
    }
  }

  function bindModal() {
    if (modal && modal.isConnected) return;
    if (modalObserver) modalObserver.disconnect();
    modal = document.getElementById('_rsi-cod-form-modal');
    if (!modal) return;
    modalObserver = new MutationObserver(schedule);
    modalObserver.observe(modal, {childList:true, subtree:true, attributes:true, attributeFilter:['data-line-item-variant-id']});
    schedule();
  }

  new MutationObserver(bindModal).observe(document.body, {childList:true, subtree:true});
  bindModal();
})();
